export type Breakpoint = "xs" | "sm" | "md" | "mg" | "lg" | "xl";
export type WithBreakpoints<T extends string> = Partial<Record<Breakpoint, T>>;

export const getSizeWithBreakpoints = <T extends string>(
  size: WithBreakpoints<T>
): WithBreakpoints<T> => ({
  xs: undefined,
  sm: undefined,
  md: undefined,
  mg: undefined,
  lg: undefined,
  xl: undefined,
  ...size,
});
